/* SHERRYS collection interactions. Event-delegated so Horizon AJAX facets/infinite scroll can replace cards. */
(() => {
  'use strict';
  if (window.__skpNativeInstalled) return;
  window.__skpNativeInstalled = true;

  let modal = null;
  let modalProduct = null;
  let selections = [];
  let lastTrigger = null;
  let isSubmitting = false;
  const wishlistStorageKey = 'skp-wishlist-v1';

  const readWishlist = () => {
    try { const a = JSON.parse(localStorage.getItem(wishlistStorageKey) || '[]'); return Array.isArray(a) ? a : []; }
    catch { return []; }
  };
  const writeWishlist = (values) => {
    try { localStorage.setItem(wishlistStorageKey, JSON.stringify(values)); return true; } catch { return false; }
  };
  const updateHearts = () => {
    const values = readWishlist();
    document.querySelectorAll('[data-skp-card]').forEach(card => {
      const isSaved = values.includes(card.dataset.skpProductId);
      const btn = card.querySelector('[data-skp-wishlist]');
      if (!btn) return;
      btn.classList.toggle('is-saved', isSaved);
      btn.setAttribute('aria-pressed', String(isSaved));
      btn.setAttribute('aria-label', isSaved ? 'Remove from wishlist' : 'Save to wishlist');
    });
  };

  function galleryShow(gallery, index) {
    const slides = Array.from(gallery.querySelectorAll('[data-skp-slide]'));
    if (!slides.length) return;
    const active = (index + slides.length) % slides.length;
    gallery.dataset.skpActive = String(active);
    slides.forEach((slide, i) => {
      const selected = i === active;
      slide.classList.toggle('is-active', selected);
      slide.toggleAttribute('aria-hidden', !selected);
      slide.tabIndex = selected ? 0 : -1;
    });
    gallery.querySelectorAll('[data-skp-index]').forEach(dot => {
      dot.classList.toggle('is-active', Number(dot.dataset.skpIndex) === active);
    });
  }

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'skp-modal';
    modal.hidden = true;
    modal.innerHTML = `
      <div class="skp-modal__backdrop" data-skp-close></div>
      <section class="skp-modal__sheet" role="dialog" aria-modal="true" aria-labelledby="skp-modal-heading" tabindex="-1">
        <div class="skp-modal__handle"></div>
        <div class="skp-modal__head">
          <h2 class="skp-modal__heading" id="skp-modal-heading">SIZE</h2>
          <button class="skp-modal__close" data-skp-close type="button" aria-label="Close">×</button>
        </div>
        <p class="skp-modal__product" data-skp-product-title></p>
        <div data-skp-groups></div>
        <button type="button" class="skp-modal__submit" data-skp-submit disabled>ADD TO BAG</button>
        <p class="skp-modal__error" role="status" data-skp-error></p>
      </section>`;
    document.body.appendChild(modal);
    return modal;
  }

  const findVariant = () => {
    if (!modalProduct) return null;
    return modalProduct.variants.find(variant =>
      variant.available && (modalProduct.options || []).every((_, i) => String(variant.options[i]) === String(selections[i]))
    ) || null;
  };

  const refreshSubmit = () => {
    const btn = modal.querySelector('[data-skp-submit]');
    const variant = findVariant();
    btn.disabled = !variant || isSubmitting;
    btn.textContent = isSubmitting ? 'ADDING…' : 'ADD TO BAG';
    modal.querySelector('[data-skp-error]').textContent = '';
    modal.querySelectorAll('[data-skp-option]').forEach(button => {
      const groupIndex = Number(button.dataset.group);
      const value = button.dataset.value;
      const selected = selections[groupIndex] === value;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
  };

  function buildGroups() {
    const region = modal.querySelector('[data-skp-groups]');
    region.replaceChildren();
    const names = modalProduct.options || [];
    const variants = modalProduct.variants || [];

    if (names.length === 1 && names[0] === 'Title') {
      selections = [variants.find(v => v.available)?.options?.[0] || 'Default Title'];
      modal.querySelector('.skp-modal__heading').textContent = 'ONE SIZE';
      return;
    }

    const order = names.map((name, i) => i).sort((a,b) => /size/i.test(names[b]) - /size/i.test(names[a]));
    modal.querySelector('.skp-modal__heading').textContent = names.some(name => /size/i.test(name)) ? 'SIZE' : 'CHOOSE OPTIONS';
    order.forEach(groupIndex => {
      const name = names[groupIndex];
      const group = document.createElement('section'); group.className = 'skp-modal__group';
      const heading = document.createElement('h3'); heading.className = 'skp-modal__group-title'; heading.textContent = name;
      const values = document.createElement('div'); values.className = 'skp-modal__values';
      const distinct = Array.from(new Set(variants.map(v => v.options?.[groupIndex]).filter(x=>x!=null)));
      distinct.forEach(value => {
        const button = document.createElement('button'); button.type='button'; button.className='skp-modal__option';
        button.textContent = String(value); button.dataset.skpOption=''; button.dataset.group=String(groupIndex); button.dataset.value=String(value);
        const canBuy = variants.some(v => v.available && String(v.options[groupIndex]) === String(value));
        button.disabled = !canBuy;
        values.appendChild(button);
      });
      group.append(heading,values); region.appendChild(group);
    });
  }

  function openModal(card, trigger) {
    const json = card.querySelector('[data-skp-product-json]');
    if (!json) return;
    try { modalProduct = JSON.parse(json.textContent); }
    catch { return; }
    if (!modalProduct.variants?.length) return;
    lastTrigger = trigger;
    ensureModal();
    selections = Array(modalProduct.options.length).fill(null);
    isSubmitting = false;
    modal.querySelector('[data-skp-product-title]').textContent = modalProduct.title;
    buildGroups(); refreshSubmit();
    modal.hidden = false;
    document.body.classList.add('skp-modal-open');
    modal.querySelector('.skp-modal__sheet').focus();
  }
  function closeModal() {
    if (!modal || modal.hidden || isSubmitting) return;
    modal.hidden = true;
    modalProduct = null;
    document.body.classList.remove('skp-modal-open');
    lastTrigger?.focus();
  }

  async function submitCart() {
    if (!modal || isSubmitting) return;
    const chosen = findVariant();
    if (!chosen) return;
    isSubmitting = true;
    refreshSubmit();
    const msg = modal.querySelector('[data-skp-error]');
    const base = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(`${base}cart/add.js`, {
        method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({id: Number(chosen.id), quantity:1}), credentials:'same-origin'
      });
      if (!response.ok) {
        const error = await response.json().catch(()=>({}));
        throw new Error(error.description || 'Could not add this product. Please try again.');
      }
      window.location.assign(`${base}cart`);
    } catch (error) {
      msg.textContent = error.message || 'Could not add this item.';
      isSubmitting = false; refreshSubmit(); msg.textContent = error.message || 'Could not add this item.';
    }
  }

  document.addEventListener('click', (event) => {
    // A swipe should not accidentally navigate to the product page.
    const slideLink = event.target.closest('[data-skp-slide]');
    if (slideLink && slideLink.closest('[data-skp-gallery]')?.dataset.skpSwiped === 'true') {
      event.preventDefault();
      delete slideLink.closest('[data-skp-gallery]').dataset.skpSwiped;
      return;
    }
    if (event.target.closest('[data-skp-close]')) { closeModal(); return; }
    const option = event.target.closest('[data-skp-option]');
    if (option && modal && !modal.hidden) {
      selections[Number(option.dataset.group)] = option.dataset.value;
      refreshSubmit(); return;
    }
    if (event.target.closest('[data-skp-submit]')) { submitCart(); return; }
    const card = event.target.closest('[data-skp-card]');
    if (!card) return;
    const wish = event.target.closest('[data-skp-wishlist]');
    if (wish) {
      const id = card.dataset.skpProductId;
      const ids = readWishlist();
      const willSave = !ids.includes(id);
      const persisted = writeWishlist(willSave ? [...ids,id] : ids.filter(v=>v!==id));
      if (persisted) updateHearts();
      else { wish.classList.toggle('is-saved', willSave); wish.setAttribute('aria-pressed', String(willSave)); }
      return;
    }
    const add = event.target.closest('[data-skp-add-open]');
    if (add) { openModal(card, add); return; }
    const gallery = event.target.closest('[data-skp-gallery]');
    if (!gallery) return;
    const current = Number(gallery.dataset.skpActive || 0);
    if (event.target.closest('[data-skp-next]')) { galleryShow(gallery, current+1); return; }
    if (event.target.closest('[data-skp-prev]')) { galleryShow(gallery, current-1); return; }
    const dot = event.target.closest('[data-skp-index]');
    if (dot) galleryShow(gallery, Number(dot.dataset.skpIndex));
  });
  document.addEventListener('keydown', event => {
    if (event.key==='Escape') closeModal();
  });
  document.addEventListener('touchstart', event => {
    const gallery = event.target.closest('[data-skp-gallery]');
    if (!gallery) return;
    gallery.dataset.skpTouchX = String(event.touches[0].clientX);
  }, {passive:true});
  document.addEventListener('touchend', event => {
    const gallery = event.target.closest('[data-skp-gallery]');
    if (!gallery || !gallery.dataset.skpTouchX) return;
    const dx = event.changedTouches[0].clientX - Number(gallery.dataset.skpTouchX);
    delete gallery.dataset.skpTouchX;
    if (Math.abs(dx) >= 36) {
      gallery.dataset.skpSwiped = 'true';
      galleryShow(gallery, Number(gallery.dataset.skpActive || 0) + (dx < 0 ? 1 : -1));
      setTimeout(() => { delete gallery.dataset.skpSwiped; }, 350);
    }
  }, {passive:true});
  window.addEventListener('storage', updateHearts);
  // Rehydrate wishlist hearts after Horizon facets replaces cards.
  const observer = new MutationObserver(records => {
    // Horizon facets/infinite-scroll replace card nodes. Ignore every other
    // mutation (cart drawer, mobile menu, images, app widgets, etc.).
    const newCards = records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 &&
      (node.matches?.('[data-skp-card]') || node.querySelector?.('[data-skp-card]'))
    ));
    if (newCards) updateHearts();
  });
  const start = () => {
    const main = document.getElementById('MainContent');
    if (main) observer.observe(main, {childList:true, subtree:true});
    updateHearts();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', updateHearts);
})();


/* SHERRYS V5: Sort markup is server-rendered by sherrys-sort-control.liquid.
   This JS handles interactions only. It does NOT insert or move Filter/Sort. */
(() => {
  'use strict';
  if (window.__skpSortControlV5) return;
  window.__skpSortControlV5 = true;
  let activeModal = null;
  let lastTrigger = null;

  function closeSort() {
    if (!activeModal) return;
    activeModal.hidden = true;
    document.body.classList.remove('skp-sort-open');
    const focusTarget = lastTrigger;
    activeModal = null;
    lastTrigger = null;
    if (focusTarget && document.contains(focusTarget)) focusTarget.focus();
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-skp-sort-open]');
    if (trigger) {
      // Snippet is collection-only; keep the native control usable even if
      // Horizon changes the collection-component wrapper during facet updates.
      const sheet = trigger.closest('.facets-toggle')?.querySelector('[data-skp-sort-modal]');
      if (!sheet) return;
      e.preventDefault();
      if (activeModal && activeModal !== sheet) closeSort();
      lastTrigger = trigger;
      activeModal = sheet;
      const value = new URL(window.location.href).searchParams.get('sort_by') || 'manual';
      const chosenLabel = ({
        'manual':'Recommended', 'best-selling':'Top Sellers', 'created-descending':'New Arrival',
        'price-ascending':'Price Low To High', 'price-descending':'Price High To Low'
      })[value] || 'Recommended';
      sheet.querySelectorAll('[data-skp-sort-value]').forEach(button => {
        button.setAttribute('aria-current', String(button.textContent.trim() === chosenLabel));
      });
      sheet.hidden = false;
      document.body.classList.add('skp-sort-open');
      sheet.querySelector('.skp-sort-sheet')?.focus();
      return;
    }
    if (e.target.closest('[data-skp-sort-close]')) {
      e.preventDefault(); closeSort(); return;
    }
    // Desktop dropdown dismisses on outside click. Mobile backdrop uses the
    // standard close selector above. Never steal Horizon filter interactions.
    if (activeModal && !activeModal.contains(e.target) && !e.target.closest('[data-skp-sort-open]')) {
      closeSort();
    }
    const sortOption = e.target.closest('[data-skp-sort-value]');
    if (sortOption) {
      e.preventDefault();
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortOption.dataset.skpSortValue);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    }
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeSort();
  });
})();
